import React from "react";

export default function TableRow({ game_name, notes1, waiting }) {
  return (
    <tr>
      <td className="subhead-3 text-primary">{game_name}</td>
      <td className="label-1">{notes1}</td>
      <td className="fs-lg fw-medium text-center">{waiting}</td>
    </tr>
  );
}
